import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import useUsers from "../../../hooks/useUsers";
import { handleLoadSelectOptions, mapValues } from "../../../util/Utilities";
import useServices from "../../../hooks/useServices";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";
import { useNavigate, useParams } from "react-router-dom";

const AcquisitionUserUpdate = () => {

    const { id } = useParams();

    const { setCustomAlert } = useFeedBack();

    const navigate = useNavigate();

    const [{ users, loading: usersLoading }, getUsers] = useUsers({ params: { perPage: 50 } }, { useCache: false });

    const [{ services, loading: servicesLoading }, getServices] = useServices({ params: { perPage: 50 } }, { useCache: false });

    const [{ data: record }, getRecord] = useAxios({ url: `/acquisition-users/${id}` }, { useCache: false });

    const [{ loading: storeLoading }, store] = useAxios({ url: `/acquisition-users/${id}`, method: 'PUT' }, { manual: true, useCache: false });

    const [data, setData] = useState({
        user: '',
        service: '',
    });

    useEffect(() => {
        if (record) {
            setData((oldData) => {
                return {
                    ...oldData,
                    service: { label: record?.data?.service?.name, value: record?.data?.service?.id },
                    user: { label: record?.data?.user?.name, value: record?.data?.user?.document_number },
                }
            });
        }
    }, [record])

    const handleChange = (e) => {

        var value = e.target.value

        if (e.target.type === 'checkbox') {
            if (data?.[e.target.name]?.includes(value)) {
                value = data?.[e.target.name]?.filter((values) => values != value);
            } else {
                value = [...data?.[e.target.name], value];
            }
        }

        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: value
            }
        });
    }

    const handleSubmit = (e) => {
        e?.preventDefault?.();

        store({
            data: {
                user_document_number: data?.user?.value,
                service_id: data?.service?.value,
            }
        }).then(() => {
            setCustomAlert({
                title: '¡Operacion Exitosa!',
                severity: 'success',
                message: `El registro fue creado exitosamente.`,
                show: true
            });
            navigate?.(`/responsables/adquisiciones/listar`);
        });
    }

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">
                    Actualizar responsable de adquisición
                </h3>
            </div>
            <form className="card-body" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <p className="text-center text-black">
                            Seleccione el usuario
                        </p>
                        <AsyncSelect
                            isClearable
                            onFocus={() => { getUsers() }}
                            value={data?.user}
                            isLoading={usersLoading}
                            defaultOptions={mapValues(users, 'documentNumber')}
                            name="user"
                            loadOptions={(e) => handleLoadSelectOptions(e, getUsers, null, 'documentNumber')}
                            placeholder='Escriba el nombre para buscar...'
                            onChange={(e) => { handleChange({ target: { value: e, name: 'user' } }) }}
                        />
                    </div>
                    <div className="col-md-12 mb-3">
                        <p className="text-center text-black">
                            Servicio
                        </p>
                        <AsyncSelect
                            isClearable
                            onFocus={() => { getServices() }}
                            value={data?.service}
                            isLoading={servicesLoading}
                            defaultOptions={mapValues(services)}
                            name="service"
                            loadOptions={(e) => handleLoadSelectOptions(e, getServices)}
                            placeholder='Escriba el nombre para buscar...'
                            onChange={(e) => { handleChange({ target: { value: e, name: 'service' } }) }}
                        />
                    </div>
                    <div className="col-md-12">
                        <button className="btn btn-primary w-100" disabled={storeLoading}>
                            {
                                storeLoading ?
                                    'Cargando'
                                    :
                                    'Guardar cambios'
                            }
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AcquisitionUserUpdate;